<template lang="pug">
v-container.pa-8(fluid)
  .d-flex.align-center.mb-4
    v-btn.mr-4(icon small)
      v-icon(color="primary" @click="onClickBack") mdi-arrow-left
    .text-2xl.font-semibold {{ $t('rooms_and_equipments') }}
  v-row.pb-2.pb-md-0(no-gutters)
    v-col(cols="12" md="8")
      v-tabs(v-model="tab" color="basic700" :height="44" @change="tabChanged" active-class="font-semibold")
        v-tab.text-sm.font-medium.text-none.px-4 {{ $t('all') }}
        v-tab.text-sm.font-medium.text-none.px-4 {{ $t('rooms') }}
        v-tab.text-sm.font-medium.text-none.px-4 {{ $t('equipments') }}
    v-col(cols="12" md="4" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
        v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="addNewFacility") {{ $t('add_item', { item: $t('new').toLowerCase() }) }}
  v-divider
  
  .data-table
    v-data-table.mt-sm-4.pb-6(:headers="headers" :items="facilities" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" @click:row="" loader-height="2" :header-props="{ sortIcon: '$yzi-triangle' }")
      template(v-slot:item.name="{ item }")
        .h9 {{ item.name }}
      template(v-slot:item.type="{ item }")
        .text-capitalize {{ item.type }}
      template(v-slot:item.description="{ item }")
        v-tooltip(top color="neutral700")
          template(#activator="{ on, attrs }")
            div(v-bind="attrs" v-on="on" style="max-width: 240px;")
              .text-sm.neutral700--text.cursor-help.ellipsis-text.my-3 {{ item.description }}
          .text-sm(style="max-width: 500px;") {{ item.description }}
      template(v-slot:item.services="{ item }")
        template(v-for="service in item.services")
          y-chip.ma-1(:label="service" size="sm" chip-class="pa-1" outlined)
      template(v-slot:item.status="{ item }")
        y-switch.mb-n3.mx-0.pa-0(v-model="item.enabled" @change="enableItem(item)")
      template(v-slot:item.action="{ item }")
        .d-flex.justify-end.py-3
          v-menu(offset-y left rounded="lg" min-width=120)
            template(#activator="{ on }")
              v-btn.ml-4(icon small v-on="on")
                v-icon mdi-dots-horizontal
            v-list.py-0
              v-list-item(@click="editItem(item)")
                .text-sm {{ $t('edit') }}
              v-divider.basic300
              v-list-item(@click="deleteItem(item)")
                .text-sm.danger500--text {{ $t('delete') }}

  .d-flex.align-center(v-if="totalCount > pageSize")
    v-spacer
    yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Item list" attach menu-top @input="pageChanged")

  .dialogs
    delete-facility-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :facility="selectedItem" @deleted="fetchFacilities")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DeleteFacilityDialog from '@/components/clinic/dialogs/DeleteFacilityDialog.vue'

export default {
  components: { DeleteFacilityDialog },
  data () {
    return {
      tab: 0,
      searchText: null,
      showSearchField: false,
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      isFetching: false,
      openConfirmDeleteTemplateDialog: false,
      filters: [],
      headers: [
        { text: 'NAME', value: 'name' },
        { text: 'TYPE', value: 'type' },
        { text: 'DESCRIPTION', value: 'description' },
        // { text: 'SERVICE', value: 'services', sortable: false },
        { text: 'STATUS', value: 'status', sortable: false, width: 120, },
        { text: 'ACTION', value: 'action', sortable: false, width: 120, class: 'text-end' }
      ],
      facilities: [],
      showDeleteDialog: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    facilityType () {
      if (this.tab === 1) {
        return 'room'
      } else if (this.tab === 2) {
        return 'equipment'
      }
      return ''
    },
  },
  watch: {
    pageSize () {
      this.fetchFacilities()
    },
  },
  mounted () {
    this.fetchFacilities()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchFacilities () {
      this.isFetching = true
      const params = {
        page: this.currentPage,
        page_size: this.pageSize,
        type: this.facilityType
      }
      this.$axios.get(`/clinics/${this.company.slug}/facilities`, { params })
        .then(resp => {
          const data = resp.data
          this.facilities = data.results
          this.facilities = this.facilities.map(item => {
            item.enabled = item.status === 'active'
            return item
          })
          this.totalCount = data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    tabChanged () {
      this.currentPage = 1
      this.fetchFacilities()
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged () {},
    onClickBack () {
      this.$router.push('/admin/clinic/settings')
    },
    pageChanged () {
      this.fetchFacilities()
    },
    onClickAction (action) {
      switch (action.id) {
        case 'edit':
          return
        case 'delete':
          return
        default:
          return
      }
    },
    editItem (item) {
      this.$router.push(`/admin/clinic/settings/facilities/${item.id}/edit`)
    },
    deleteItem (item) {
      this.showDeleteDialog = true
      this.selectedItem = item
    },
    addNewFacility () {
      this.$router.push('/admin/clinic/settings/new-facility')
    },
    enableItem (item) {
      this.$axios.patch(`/clinics/${this.company.slug}/facilities/${item.id}`, { status: item.enabled ? 'active' : 'inactive' })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  },
}
</script>

<style lang="scss" scoped>
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>